import PropTypes from "prop-types";
import ProductHeroContainer from "../../../../../ProductHeroContainer";
import styles from "./index.css";

const EagerImage = ({ ImageComponent, ...rest }) => (
  <ProductHeroContainer className={styles.productTileProductHero}>
    <ImageComponent {...rest} />
  </ProductHeroContainer>
);

EagerImage.propTypes = {
  ImageComponent: PropTypes.elementType.isRequired
};

export default EagerImage;
